export default __webpack_public_path__ + "static/media/Bronze.0f394ba5.png";